import React from 'react'
import { Text, Button, LoadingSpinner } from './ui'
import { ExclamationTriangleIcon, ArrowPathIcon } from '@heroicons/react/24/outline'

interface LoadingWithRetryProps {
  loading: boolean
  error: string | null
  retryCount: number
  onRetry: () => void
  loadingMessage?: string
  errorMessage?: string
  children: React.ReactNode
}

const LoadingWithRetry: React.FC<LoadingWithRetryProps> = ({
  loading,
  error,
  retryCount,
  onRetry,
  loadingMessage = 'Carregando...',
  errorMessage = 'Erro ao carregar dados',
  children
}) => {
  if (loading) {
    return (
      <div className="flex h-screen bg-gray-100 dark:bg-gray-900">
        <div className="flex-1 flex items-center justify-center w-full">
          <div className="text-center">
            <LoadingSpinner size="lg" className="mx-auto mb-4" />
            <Text size="lg" className="text-gray-600 dark:text-gray-400 mb-2">
              {loadingMessage}
            </Text>
            {retryCount > 0 && (
              <Text size="sm" className="text-gray-500 dark:text-gray-500">
                Tentativa {retryCount} de 3...
              </Text>
            )}
          </div>
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="flex h-screen bg-gray-100 dark:bg-gray-900">
        <div className="flex-1 flex items-center justify-center w-full">
          <div className="text-center max-w-md">
            <ExclamationTriangleIcon className="h-12 w-12 text-red-500 mx-auto mb-4" />
            <Text size="lg" className="text-red-600 dark:text-red-400 mb-2">
              {errorMessage}
            </Text>
            <Text size="sm" className="text-gray-600 dark:text-gray-400 mb-4">
              {error}
            </Text>
            <Button
              onClick={onRetry}
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 mx-auto"
            >
              <ArrowPathIcon className="h-4 w-4" />
              Tentar Novamente
            </Button>
            {retryCount > 0 && (
              <Text size="xs" className="text-gray-500 dark:text-gray-500 mt-2">
                Já tentamos {retryCount} vezes
              </Text>
            )}
          </div>
        </div>
      </div>
    )
  }

  return <>{children}</>
}

export default LoadingWithRetry
